export const menuItems = [
    {
        key: '1',
        label: "Теги",
    },
    {
        key: '2',
        label: "Регламент",
    }
]